import CarModels from "@/app/components/CarModels/CarModels";
import CarModelMobile from "@/app/components/CarModels/CarModelsMobile";
import CookiePreferencesButton from "@/app/components/CookieConsent/CookiePreferencesButton";
import CustomLink from "@/app/components/CustomLink";
import { COOKIE_POLICY_PATH } from "@/app/config/cookie-consent";
import { BRAND_NAMES } from "@/app/utils/utils";
import { AiOutlineFilePdf } from "react-icons/ai";
import React from "react";
import styles from "@/styles/desktop/About/Sobre.module.scss";


const useIsMobile = () => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  return isMobile;
};

interface PageProps {}

const Page: React.FC<PageProps> = () => {
  const [showAllFinancial, setShowAllFinancial] = React.useState(false);
  const [visibleImages, setVisibleImages] = React.useState<Set<string>>(new Set());
  const isMobile = useIsMobile();
  
  React.useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const imageId = entry.target.getAttribute('data-image-id');
            if (imageId) {
              setVisibleImages(prev => new Set([...prev, imageId]));
            }
          }
        });
      },
      {
        threshold: 0.3,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    const images = document.querySelectorAll('[data-image-id]');
    images.forEach((img) => observer.observe(img));

    return () => observer.disconnect();
  }, []);

  /*const financialStatements = [
    {
      year: "2023",
      title: `Demonstrações Contábeis ${BRAND_NAMES.DEFAULT} NE`,
      href: "https://www.kurumaveiculos.com.br/docs/demonstracoes_cont%C3%A1beis_kuruma_veiculos_2023.pdf",
    },
    {
      year: "2022",
      title: `Demonstrações Contábeis ${BRAND_NAMES.DEFAULT} NE`,
      href: "https://www.kurumaveiculos.com.br/docs/demonstracoes_contabeis_kuruma_veiculos_2022.pdf",
    },
    {
      year: "2021",
      title: `Demonstrações Contábeis ${BRAND_NAMES.DEFAULT} NE`,
      href: "https://www.kurumaveiculos.com.br/docs/demonstracoes_contabeis_kuruma_veiculos_2021.pdf",
    },
    {
      year: "2020",
      title: `Demonstrações Contábeis ${BRAND_NAMES.DEFAULT} NE`,
      href: "https://drive.google.com/file/d/18ZYb_g3ZldetzUCof9v-cCd6s-qDJw6M/view",
    },
    {
      year: "2019",
      title: `Demonstrações Contábeis ${BRAND_NAMES.DEFAULT} NE`,
      href: "https://drive.google.com/file/d/1jdWLPdJ1bi5VU_j1_mH40bImRC7RC_hO/view",
    },
    {
      year: "2018",
      title: `Demonstrações Contábeis ${BRAND_NAMES.DEFAULT} NE`,
      href: "https://drive.google.com/file/d/1DDFJsTLPZKb2cz7j-uVzXnrv9lVCs_0w/view",
    },
    {
      year: "2017",
      title: `Demonstrações Contábeis ${BRAND_NAMES.DEFAULT} NE`,
      href: "https://drive.google.com/file/d/1CxmUfyRlnQlzePSwonui_pURfxujjKL1/view",
    },
    {
      year: "2016",
      title: `Demonstrações Contábeis ${BRAND_NAMES.DEFAULT} NE`,
      href: "https://drive.google.com/file/d/1SWDKMDkzANibtQHox3P7lxnnWVWUu1HM/view",
    },
    {
      year: "2015",
      title: `Demonstrações Contábeis ${BRAND_NAMES.DEFAULT} NE`,
      href: "https://drive.google.com/file/d/11pXzUlvWNFtC-LBxD0Ots0-5Chs6BZlw/view",
    },
    {
      year: "2014",
      title: `Demonstrações Contábeis ${BRAND_NAMES.DEFAULT} NE`,
      href: "https://drive.google.com/file/d/13T0AN3-ikp6AzYAvzgNTIPEhtV8eJGFn/view",
    },
  ];*/

  const technicalNote = {
    title:
      "NOTA TÉCNICA ACERCA DOS RELATÓRIOS DE TRANSPARÊNCIA E IGUALDADE SALARIAL DO MINISTÉRIO DO TRABALHO E EMPREGO",
    href: "https://bloblandingpageprd.blob.core.windows.net/toyota/geral/relatorios-tela-sobre-nos/2027/Relatorio-de-transparencia-Kuruma-Brasilia-SIA-2027.pdf",
  };


  return (
    <>
      <div className={styles.sobrePage}>
        <main className={styles.mainContainer}>
          <div className={styles.contentWrapper}>
            <div className={styles.heroSection}>
              <div className={styles.imageContainer}>
                <img
                  src="https://bloblandingpageprd.blob.core.windows.net/toyota/geral/sobre/Fachada.jpeg"
                  alt="Fachada da concessionária Kyoto Toyota"
                  className={`${styles.mainImage} ${
                    visibleImages.has('sobre-kuruma') ? styles.visible : ''
                  }`}
                  data-image-id="sobre-kuruma"
                  loading="eager"
                  decoding="async"
                />
                <img
                  src="https://bloblandingpageprd.blob.core.windows.net/toyota/geral/sobre/Oficina (2).PNG"
                  alt="Detalhe da concessionária Kyoto"
                  className={`${styles.overlayImage} ${
                    visibleImages.has('sobre-kuruma-2') ? styles.visible : ''
                  }`}
                  data-image-id="sobre-kuruma-2"
                  loading="eager"
                  decoding="async"
                />
                <img
                  src="/images/logo_toyota.png"
                  alt="Logo Toyota"
                  className={`${styles.logoImage} ${
                    visibleImages.has('sobre-kuruma-logo') ? styles.visible : ''
                  }`}
                  data-image-id="sobre-kuruma-logo"
                  loading="eager"
                  decoding="async"
                />
              </div>
              
              <div className={styles.textContent}>
                <header className={styles.header}>
                  <div className={styles.titleContainer}>
                    <h2>
                      Sobre a {BRAND_NAMES.DEFAULT}
                    </h2>
                    <div className={styles.underline} />
                  </div>
                </header>
                
                <section className={styles.description}>
                  <p>
                    <strong>Em 2021, o Grupo Águia Branca abriu caminhos ao inaugurar sua própria concessionária da prestigiada montadora japonesa em Brasília, consolidando sua presença no setor automotivo e fortalecendo a conexão entre a excelência japonesa e o mercado brasiliense.</strong>
                  </p>
                  <p>
                    Foi nesse ano que a Kyoto nasceu, com a inauguração de três concessionárias, assumindo a revenda de automóveis Toyota e Lexus em Brasília.
                  </p>
                  <p>
                    Hoje, a Kyoto está presente em diversas cidades do Distrito Federal, incluindo SIA, Taguatinga e Epia Sul. Nossa expansão reflete o compromisso em levar a qualidade Toyota a cada vez mais clientes.
                  </p>
                </section>
              </div>
            </div>
            
            <div className={styles.standardsSection}>
              <div className={styles.standardCard}>
                <h3>Padrões Globais</h3>
                <p>
                  As concessionárias Toyota do Grupo Águia Branca seguem rigorosamente os padrões globais da montadora, com o propósito de proporcionar aos nossos clientes uma experiência de compra e posse inigualável no mercado automotivo.
                </p>
                <div className={styles.imageContainer}>
                  <img
                    src="https://bloblandingpageprd.blob.core.windows.net/toyota/geral/sobre/Entrega.png"
                    alt="Padrões Globais Toyota"
                    className={`${styles.standardImage} ${
                      visibleImages.has('padroes_globais_image') ? styles.visible : ''
                    }`}
                    data-image-id="padroes_globais_image"
                    loading="eager"
                    decoding="async"
                  />
                  <img
                    src="/images/logo_toyota.png"
                    alt="Logo Toyota"
                    className={`${styles.standardLogo} ${
                      visibleImages.has('padroes_globais_logo') ? styles.visible : ''
                    }`}
                    data-image-id="padroes_globais_logo"
                    loading="eager"
                    decoding="async"
                  />
                </div>
              </div>
              
              <div className={`${styles.standardCard} ${styles.middleCard}`}>
                <div className={styles.imageContainer}>
                  <img
                    src="https://bloblandingpageprd.blob.core.windows.net/toyota/geral/sobre/Oficina.PNG"
                    alt="78 anos de excelência"
                    className={`${styles.standardImage} ${
                      visibleImages.has('padroes_globais_image_2') ? styles.visible : ''
                    }`}
                    data-image-id="padroes_globais_image_2"
                    loading="eager"
                    decoding="async"
                  />
                  <img
                    src="/images/logo_toyota.png"
                    alt="Logo Toyota"
                    className={`${styles.standardLogo} ${
                      visibleImages.has('padroes_globais_logo_2') ? styles.visible : ''
                    }`}
                    data-image-id="padroes_globais_logo_2"
                    loading="eager"
                    decoding="async"
                  />
                </div>
                <h3>Padrão de Excelência</h3>
                <p>
                  Há mais de 78 anos, o Grupo Águia Branca tem sido sinônimo de excelência, inovação e expansão contínua.
                </p>
              </div>
              
              <div className={`${styles.standardCard} ${styles.lastCard}`}>
                <img
                  src="/images/top-about.svg"
                  alt=""
                  className={styles.iconImage}
                />
                <div className={styles.imageContainer}>
                  <img
                    src="https://bloblandingpageprd.blob.core.windows.net/toyota/geral/sobre/Interno.jpeg"
                    alt="Maior representante Toyota"
                    className={`${styles.standardImage} ${
                      visibleImages.has('padroes_globais_image_3') ? styles.visible : ''
                    }`}
                    data-image-id="padroes_globais_image_3"
                    loading="eager"
                    decoding="async"
                  />
                  <img
                    src="/images/logo_toyota_preto.png"
                    alt="Logo Toyota"
                    className={`${styles.standardLogo} ${
                      visibleImages.has('padroes_globais_logo_3') ? styles.visible : ''
                    }`}
                    data-image-id="padroes_globais_logo_3"
                    loading="eager"
                    decoding="async"
                  />
                </div>
                <h3>Representante</h3>
                <p>
                  Somos o maior representante da Toyota na América Latina e o maior grupo de concessionárias Lexus no Brasil.
                </p>
              </div>
            </div>
  
            <div className={styles.groupSection}>
              <div className={styles.imageContainer}>
                <img
                  src="https://bloblandingpageprd.blob.core.windows.net/toyota/geral/sobre/grupo_ag.png"
                  alt="Fachada da concessionária Kyoto Toyota"
                  className={`${styles.mainImage} ${
                    visibleImages.has('grupo_ag') ? styles.visible : ''
                  }`}
                  data-image-id="grupo_ag"
                  loading="eager"
                  decoding="async"
                />
                <img
                  src="https://bloblandingpageprd.blob.core.windows.net/toyota/geral/sobre/Oficina (2).PNG"
                  alt="Detalhe da concessionária Kyoto"
                  className={`${styles.overlayImage} ${
                    visibleImages.has('grupo_ag_2') ? styles.visible : ''
                  }`}
                  data-image-id="grupo_ag_2"
                  loading="eager"
                  decoding="async"
                />
                <img
                  src="/images/logo_toyota.png"
                  alt="Logo Toyota"
                  className={`${styles.logoImage} ${
                    visibleImages.has('grupo_ag_logo') ? styles.visible : ''
                  }`}
                  data-image-id="grupo_ag_logo"
                  loading="eager"
                  decoding="async"
                />
              </div>
              
              <div className={styles.textContent}>
                <header className={styles.header}>
                  <div className={styles.titleContainer}>
                    <h2>
                      Grupo Águia Branca
                    </h2>
                    <div className={styles.underline} />
                  </div>
                </header>
                
                <section className={styles.description}>
                  <p>
                    <strong>Com presença nacional, o grupo se destaca em setores estratégicos como transporte de passageiros, logística e comércio de veículos.</strong>
                  </p>
                  <p>
                  Somos o maior representante da Toyota na América Latina e o maior grupo de concessionárias Lexus no Brasil. Contamos com mais de 100 concessionárias espalhadas pelo país e a força de mais de 20 mil colaboradores, com certificação GPTW, movidos pela paixão de oferecer o melhor em todas as nossas operações.
                  </p>
                  <p>
                  Como representantes da Toyota em três estados — Distrito Federal, Minas Gerais e Espírito Santo —, temos orgulho de honrar diariamente o compromisso com a qualidade e confiabilidade, valores que definem a Toyota mundialmente. Nossa jornada é impulsionada pela paixão em conectar pessoas e oportunidades, sempre oferecendo produtos e serviços de excelência.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </main>
  
        <div className={styles.linksSection}>
          <CustomLink
            href="https://grupoaguiabranca.empregare.com/pt-br"
            className={styles.link}
          >
            Trabalhe Conosco
            <img src="/images/Vector.svg" alt="" />
          </CustomLink>
          
          <CustomLink
            href="https://www.contatoseguro.com.br/compliancecomercio"
            className={styles.link}
          >
            Canal Compliance
            <img src="/images/Vector.svg" alt="" />
          </CustomLink>
          
          <CustomLink
            href="https://privacidadecomercio.aguiabranca.com.br/"
            className={styles.link}
          >
            Portal de Privacidade
            <img src="/images/Vector.svg" alt="" />
          </CustomLink>

          <CustomLink href={COOKIE_POLICY_PATH} className={styles.link}>
            Política de Cookies
          </CustomLink>

          <CookiePreferencesButton className={styles.link}>
            Mostrar preferências de cookie
          </CookiePreferencesButton>
        </div>
  
        {/* SEÇÃO COM FUNDO QUE COBRE TODA A TELA */}
        <div className={styles.financialSection}>
          <div className={styles.contentContainer}>
            <div className={styles.contentWrapper}>
              <div className={styles.financialCard}>
                {/* Demonstrações Financeiras */}
                {/*<div className={styles.financialContent}>
                  <div className={styles.financialText}>
                    <section className={styles.description}>
                      <header className={styles.header}>
                        <div className={styles.titleContainer}>
                          <h2>Demonstrações Financeiras</h2>
                          <div className={styles.underline} />
                        </div>
                      </header>
                      <p>
                        Disponibilizamos nessa página os demonstrativos financeiros da {BRAND_NAMES.DEFAULT} Veículos S/A. Downloads disponíveis nos
                        links abaixo: 
                      </p>
                    </section>
                  </div>
  
                  <div className={styles.financialGrid}>
                    <div className={styles.statementsGrid}>
                      {financialStatements
                        .slice(0, showAllFinancial ? undefined : 4)
                        .map((statement, index) => (
                          <article
                            key={"statement.." + index}
                            className={styles.statementCard}
                          >
                            <div className={styles.yearContainer}>
                              <img
                                loading="lazy"
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/54261e26ec34b836db5abc12c05d382641f3208f44915e56640aacb68a8cb332?placeholderIfAbsent=true&apiKey=eac21aa640a54d679c8b4aff1d0cf286"
                                alt=""
                              />
                              <div className={styles.year}>{statement.year}</div>
                            </div>
                            <CustomLink
                              href={statement.href}
                              target="_blank"
                              className={styles.statementLink}
                            >
                              {statement.title}
                            </CustomLink>
                          </article>
                        ))}
                    </div>
  
                    {financialStatements.length > 4 && (
                      <div className={styles.showMoreButton}>
                        <button
                          onClick={() => setShowAllFinancial(!showAllFinancial)}
                        >
                          {showAllFinancial ? "Ver menos" : "Ver mais +"}
                        </button>
                      </div>
                    )}
                  </div>
                </div>*/}
  
                {/* Divider */}
                <div className={styles.divider}></div>
  
                {/* Nota Técnica */}
                <div className={styles.technicalNoteContent}>
                  <div className={styles.technicalText}>
                    <section className={styles.description}>
                      <header className={styles.header}>
                        <div className={styles.titleContainer}>
                          <h2>Nota Técnica</h2>
                          <div className={styles.underline} />
                        </div>
                      </header>
                      <p>
                        Confira abaixo nossa nota técnica e documentação importante:
                      </p>
                    </section>
                  </div>
  
                  <div className={styles.technicalGrid}>
                    <div className={styles.notesGrid}>
                      {[technicalNote].map((note, i) => (
                        <article
                          key={i}
                          className={styles.noteCard}
                        >
                          <div className={styles.pdfIcon}>
                            <AiOutlineFilePdf />
                          </div>
                          <CustomLink
                            href={note.href}
                            target="_blank"
                            className={styles.noteLink}
                          >
                            {note.title}
                          </CustomLink>
                        </article>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        
      {isMobile ? (
        <div className={styles.carModelsMobileSection}>
          <CarModelMobile />
        </div>
      ) : (
        <div className={styles.carModelsSection}>
          <CarModels />
        </div>
      )}
    </>
  );
  };
  
  export default Page;


